import { useMutation } from '@tanstack/react-query';

import { agent } from 'api/agent';

interface Props {
  code: string;
}

const sendCodeForChangeOrConfirmPhoneMutation = () => useMutation({
  mutationKey: ['sendCodeForChangeOrConfirmPhone'],
  mutationFn: (body: Props) => agent.getClient(false).patch('auth/phone-number', body),
});

export default sendCodeForChangeOrConfirmPhoneMutation;
